module.exports = __webpack_public_path__ + "img/avatar.66943809.png";